<template>
  <v-slide-y-transition mode="out-in">
    <v-container>
      <v-layout justify-left row wrap>
        <v-flex xs12>
          <v-toolbar
            dark
            color="grey lighten-1">
            <v-icon class="fas fa-dumbbell"></v-icon>
            <v-toolbar-title>When Is Training an Appropriate Performance Intervention?</v-toolbar-title>
          </v-toolbar>
          <v-card>
            <v-container fluid>
              <h3>What is the performance issue?</h3>
              <div class="evaluation-container">
                
                <div class="evaluation-point">
                  <div class="evaluation-text">Does the employee know what is expected?</div>
                  <div class="arrow">
                    <div class="decision">No?</div>
                    <div class="point"></div>
                    <div class="line"></div>
                  </div>
                  <div class="evaluation-text">Establish & communicate expectations</div>
                </div>
                <div class="evaluation-point">
                  <div class="evaluation-divider">
                    <div class="evaluation-pill">If yes, continue</div>
                  </div>
                </div>

                <div class="evaluation-point">
                  <div class="evaluation-text">Does the employee have the ability to do the job?</div>
                  <div class="arrow">
                    <div class="decision">No?</div>
                    <div class="point"></div>
                    <div class="line"></div>
                  </div>
                  <div class="evaluation-text">Change job requirements, find a different way to do the job, or terminate the employee</div>
                </div>
                <div class="evaluation-point">
                  <div class="evaluation-divider">
                    <div class="evaluation-pill">If yes, continue</div>
                  </div>
                </div>
                
                <div class="evaluation-point">
                  <div class="evaluation-text">Are there any workplace obstacles preventing the employee from doing the job correctly?</div>
                  <div class="arrow">
                    <div class="decision">Yes?</div>
                    <div class="point"></div>
                    <div class="line"></div>
                  </div>
                  <div class="evaluation-text">Remove obstacles or find ways to compensate for them</div>
                </div>
                <div class="evaluation-point">
                  <div class="evaluation-divider">
                    <div class="evaluation-pill">If no, continue</div>
                  </div>
                </div>
                
                <div class="evaluation-point">
                  <div class="evaluation-text">Are there consequences when the employee fails to meet expectations?</div>
                  <div class="arrow">
                    <div class="decision">No?</div>
                    <div class="point"></div>
                    <div class="line"></div>
                  </div>
                  <div class="evaluation-text">Work with management to create meaningful consequences</div>
                </div>
                <div class="evaluation-point">
                  <div class="evaluation-divider">
                    <div class="evaluation-pill">If yes, continue</div>
                  </div>
                </div>
                
                <div class="evaluation-point">
                  <div class="evaluation-text">Are there rewards when the employee meets expectations?</div>
                  <div class="arrow">
                    <div class="decision">No?</div>
                    <div class="point"></div>
                    <div class="line"></div>
                  </div>
                  <div class="evaluation-text">Work with management to create meaningful rewards</div>
                </div>
                <div class="evaluation-point">
                  <div class="evaluation-divider">
                    <div class="evaluation-pill">If yes, continue</div>
                  </div>
                </div>
                
                <div class="evaluation-point">
                  <div class="evaluation-text">Could the employee do the job if he or she wanted to or had to, but is not doing so?</div>
                  <div class="arrow">
                    <div class="decision">Yes?</div>
                    <div class="point"></div>
                    <div class="line"></div>
                  </div>
                  <div class="evaluation-text">Go back to the beginning and work through the flowchart again</div>
                </div>
                <div class="evaluation-point">
                  <div class="evaluation-divider">
                    <div class="evaluation-pill">If no...</div>
                  </div>
                </div>
                
                <div class="evaluation-point">
                  <div class="evaluation-text"><router-link to="/contact">Provide Training</router-link></div>
                </div>
              </div>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-slide-y-transition>
</template>

<script>
export default {
  name: 'evaluation'
}
</script>

<style>
.evaluation-container {
  display: flex;
  flex-direction: row;
  flex-flow: wrap;
}
.evaluation-point {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
.evaluation-text {
  padding: 10px;
  margin: 2.5%;
  width: 121px;
  font-size: .9em;
  border-radius: 5px;
  background: #BDBDBD;
}
.evaluation-divider {
  width: 121px;
  display: flex;
  justify-content: center;
}
.evaluation-pill {
  width: 110px;
  padding: 5px;
  font-size: .9em;
  text-align: center;
  border-radius: 10px;
  background: #966464;
  color: #ffffff;
}
.evaluation-pill {
	position: relative;
	background: #966464;
	border: 4px solid #966464;
}
.evaluation-pill:after, .evaluation-pill:before {
	top: 100%;
	left: 50%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
}
.evaluation-pill:after {
	border-color: rgba(150, 100, 100, 0);
	border-top-color: #966464;
	border-width: 20px;
	margin-left: -20px;
}
.evaluation-pill:before {
	border-color: rgba(150, 100, 100, 0);
	border-top-color: #966464;
	border-width: 26px;
	margin-left: -26px;
}
.arrow {
  position: relative;
  display: inline-block;
  height: 30px;
  width: 60px;
  margin-top: 20%;
  margin-bottom: 20%;
}
.decision {
  position: absolute;
  left: -5px;
  top: -5px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  color: #FFF;
  font-size: .85em;
  text-align: center;
  line-height: 30px;
  background: #966464;
}
.line {
    margin-top: 5px;
    width: 38.5px;
    background: #966464;
    height: 7px;
    float: right;
}
.point {    
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-left: 16px solid #966464;
    float:right;
}
@media all and (min-width: 420px) {
  .evaluation-divider {
    width: 45%;
  }
  .evaluation-pill:after, .evaluation-pill:before {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  .evaluation-pill:after {
    border-color: rgba(150, 100, 100, 0);
    border-top-color: #966464;
    border-width: 20px;
    margin-left: -20px;
  }
  .evaluation-pill:before {
    border-color: rgba(150, 100, 100, 0);
    border-top-color: #966464;
    border-width: 26px;
    margin-left: -26px;
  }
  .evaluation-text {
    width: 40%;
    font-size: 1em;
  }
  .arrow {
    width: 75px;
    margin-top: 5%;
    margin-bottom: 5%;
  }
  .decision {
    left: -10px;
    width: 35px;
    height: 35px;
    line-height: 35px;
  }
  .line {
    margin-top: 8px;
    width: 47.5px;
  }
  .point {
    border-top: 12px solid transparent;
    border-bottom: 12px solid transparent;
    border-left: 25px solid #966464;
  }
}
@media all and (min-width: 814px) {
  .evaluation-text {
    width: 40%;
    font-size: 1.25em;
  }
  .arrow {
    width: 75px;
    margin-top: 3%;
    margin-bottom: 3%;
  }
  .decision {
    width: 40px;
    height: 40px;
    line-height: 40px;
  }
  .line {
    margin-top: 8px;
    width: 50px;
    height: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Evaluation.vue